<div class="wrapper__headerComponent container my-1">
  <div class="row align-items-center">
    <div class="col-12 col-xl-12">
      <h2 class="text-center h3-tipografia-govco mb-0">{{"form_validar_usuario.titulo" | translate}}</h2>
    </div>
  </div>
</div>
<div class="wrapper__contentComponent--cuenta container my-5">
  <div class="row align-items-center">
    <div class="col-2"></div>
    <div class="col-8">
      <app-form
        [fields]="validarUsuarioForm"
        [withSubmitButton]="true"
        [sumbitButtonText]="this.validarUsuarioText['titulo_btn']"
        (submitAction)="onSubmitValidarUsuario($event)">
      </app-form>
    </div>
    <div class="col-2"></div>
  </div>
</div>
